import {CalculatorValueType} from "../types/CalculatorValueType";
import {ICalculatorOptions} from "../types/ICalculatorOptions";

export const setFiltersStateInitialValue = (type: CalculatorValueType, initialValues: ICalculatorOptions[]) => {
    switch (type) {
        case CalculatorValueType.PRICE:
            return initialValues.find((data) => data.valueType === CalculatorValueType.PRICE)?.values.init || 0;
        case CalculatorValueType.PERIOD:
            return initialValues.find((data) => data.valueType === CalculatorValueType.PERIOD)?.values.init || 0;
        case CalculatorValueType.CONTRIBUTION:
            const price = initialValues.find((data) => data.valueType === CalculatorValueType.PRICE)?.values.init;
            const contribution = initialValues.find((data) => data.valueType === CalculatorValueType.CONTRIBUTION)?.values.init;

            if (price && contribution) {
                return (price * contribution) / 100;
            }

            return 0;
        default:
            return 0;
    }
};
import {CalculatorValueType} from "../types/CalculatorValueType";
import {ICalculatorOptions} from "../types/ICalculatorOptions";

export const setFiltersStateInitialValue = (type: CalculatorValueType, initialValues: ICalculatorOptions[]) => {
    switch (type) {
        case CalculatorValueType.PRICE:
            return initialValues.find((data) => data.valueType === CalculatorValueType.PRICE)?.values.init || 0;
        case CalculatorValueType.PERIOD:
            return initialValues.find((data) => data.valueType === CalculatorValueType.PERIOD)?.values.init || 0;
        case CalculatorValueType.CONTRIBUTION:
            const price = initialValues.find((data) => data.valueType === CalculatorValueType.PRICE)?.values.init;
            const contribution = initialValues.find((data) => data.valueType === CalculatorValueType.CONTRIBUTION)?.values.init;

            if (price && contribution) {
                return (price * contribution) / 100;
            }

            return 0;
        default:
            return 0;
    }
};
